import { T }         from 'defa-object';
import ControlModule from 'scripts/poppet/control-module';
import template      from './controlBatteryAlertView.jst.html';
import { Vue }       from 'vue/defavue';

const batterySwitchOptions     = [
	{ value: 'ON', 	title: T.tc( 'HomeAlert', 'On' ), 	titleContext: 'HomeAlert' },
	{ value: 'OFF', title: T.tc('HomeAlert', 'Off' ),	titleContext: 'HomeAlert' }
];

export const ControlBatteryAlertView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	
	className: function () {
		return this._getClassName( 'control-home-alerts' );
	},
	
	onDomRefresh() {
		let self   = this;
		
		new Vue ({
			el: '#battery-slider',
			
			bb() {
				return {
					model: self.model,
				};
			},
			
			data() {
				return {
					batterySwitchValue: 'ON',
					batterySwitchOptions,
				}
			},
			methods : {
				save(newValue, attributeName) {
					let data = {};
					data[attributeName]= {
						batteryFailure: 'ON' === this.batterySwitchValue,
						lowBattery    : 'ON' === this.batterySwitchValue
					};
					self.save( data )
				},
			},
			
			watch: {
				'model.batteryAlarmMask': function (newAttribute){
					this.batterySwitchValue = newAttribute.batteryFailure &&  newAttribute.lowBattery ? 'ON' : 'OFF';
				}
			},
			
			created() {
				this.batterySwitchValue = this.model.batteryAlarmMask && this.model.batteryAlarmMask.batteryFailure && this.model.batteryAlarmMask.lowBattery  ? 'ON' : 'OFF';
			}
		});
	},
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	save: function (attributes) {
		this.model.set('isValidData', false);
		try {
			this.model.save( attributes, {
				isSaving: true,
				patch: true,
				success: function () {
					console.log( Object.keys(attributes)[0] +' was succesfully saved!' );
				},
				error  : function (model, response) {
					console.error( Object.keys(attributes)[0] + ' failed saving with error: ' + response.responseJSON.message );
				}
			} );
		} catch ( err ) {
			alert( 'Failed syncing' );
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	},
});

export default  ControlBatteryAlertView;
